module.exports = __webpack_public_path__ + "img/forestDetailSurvival.0426b29c.svg";